'use client'
import {
  Stack
} from "./chunk-ZHMYA64R.mjs";

// src/stack/h-stack.tsx
import { forwardRef } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var HStack = forwardRef((props, ref) => /* @__PURE__ */ jsx(Stack, { align: "center", ...props, direction: "row", ref }));
HStack.displayName = "HStack";

export {
  HStack
};
//# sourceMappingURL=chunk-3ASUQ6PA.mjs.map